import { useEffect, useState } from "react";
import { Link } from "react-router-dom";


import Pagination from '@mui/material/Pagination';

export const PickupMasterTable = (
    {
        handleEdit,
        filterData,
        handlePrint,
        Filter = false,
        handleClick,
        handleChange1,
        currentPageNo,
        setFilterData,
        handleFilter,
        handleDelete,
        getTrackingData,
        trackingTabledata,
        loading,
        isModalOpen,
        closeModal,
        tableData,
    }) => {

    const finalHeaderKeys = tableData?.HeadersValue?.filter(

        (key, index) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );
    const finalHeadersValue = tableData?.HeadersKey?.filter(
        (key) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );
    const [ColoredRow, setColoredRow] = useState('')
    const handleHighlight = (id) => {
        setColoredRow(id)
    }
    const [serchingData, setSerchingData] = useState([])
    const serching = async () => {
        if (Filter) {
            let data = await
                await fetch(`/api/DashboardController/GetDistrictWiseData`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
            setSerchingData(data.dataList)
            setFilterData({ ...filterData, SearchFieldValue: data.dataList[0].valuePart })
        }
    }

    const countNo = Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize)))
    useEffect(() => {
        serching()
    }, [])
    return (
        <>  {
            tableData ? (
                <div className='' >
                 
                    {tableData.TotalRecord === undefined  ? <></> :
                        <div className='recoard-bata service-content-area'>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className='light-bg'>

                                            {tableData?.Actions.length !== 0 ? (
                                                <th>Action</th>
                                            ) : (
                                                <></>
                                            )}
                                            {finalHeaderKeys?.map((th, headIndex) => (
                                                <th key={`th${headIndex || 0}`}>{th}</th> || <></>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {tableData?.Data?.map((item, bodyIndex) => (
                                            <tr key={`row${bodyIndex}`} className="tablerow" onClick={() => handleHighlight(bodyIndex)} style={{ background: bodyIndex === ColoredRow ? '#cbe2ff' : '' }}>
                                                {tableData?.Actions.length != 0 ? (
                                                    <td className='d-flex'>
                                                        {tableData.Actions?.map((btn, index) => (
                                                            <>
                                                                {btn === 'Edit' ?
                                                                    <button key={`edit${index}`} className="btn btn-xs sharp me-1" onClick={() => handleEdit(item.Edit)}>
                                                                        <i className="fa-regular fa-pen-to-square text-success" />
                                                                    </button> : (<></>)}
                                                                {btn === 'Del' ?
                                                                    <button key={`del${index}`} className="btn btn-xs sharp" onClick={() => handleDelete(item.Del)}>
                                                                        <i className="fa-regular fa-trash-can text-danger" />
                                                                    </button> : (<></>)}
                                                                {btn === 'Print' ?
                                                                    <button key={`print${index}`} className="btn btn-xs sharp" onClick={() => handlePrint(item.Print)}>
                                                                        <i className="fa fa-download text-primary" />
                                                                    </button> : (<></>)}
                                                            </>
                                                        ))}
                                                    </td>
                                                ) : (
                                                    <></>
                                                )}
                                                {finalHeadersValue.filter((value) => value !== 'Map').map((key, tdIndex) => (
                                                    <td
                                                        key={`key${tdIndex}`}
                                                        onClick={key === 'TRUNKID' ? () => handleClick(item[key]) : null}
                                                        style={key === 'TRUNKID' ? { cursor: 'pointer', color: '#6AB3F9' } : {}}
                                                    >
                                                        {item[key]}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {countNo > 1 ?
                                < Pagination className='pt-2' count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange1} shape="rounded" />
                                : ''}
                        </div>
                    }
                </div >
            ) : (<></>)
        }

        </>
    )
}